/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const Wifi: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="wifi" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M56.6666666666667 850L170 736.6666666666667C451.6333333333333 1018.3 908.3666666666666 1018.3 1190 736.6666666666667L1303.3333333333333 850C959.3666666666666 1193.9666666666667 401.2 1193.9666666666667 56.6666666666667 850zM510 396.6666666666668L680 226.6666666666668L850 396.6666666666668A240.0966666666667 240.0966666666667 0 0 1 510 396.6666666666668zM283.3333333333333 623.3333333333334L396.6666666666667 510A400.86 400.86 0 0 0 963.3333333333331 510L1076.6666666666665 623.3333333333334C857.9333333333333 842.0666666666666 502.6333333333333 842.0666666666666 283.3333333333333 623.3333333333334z" : "M45.3333333333333 680L136 589.3333333333333C361.3066666666667 814.64 726.6933333333334 814.64 952 589.3333333333333L1042.6666666666667 680C767.4933333333333 955.1733333333332 320.9600000000001 955.1733333333332 45.3333333333333 680zM408 317.3333333333333L544 181.3333333333333L680 317.3333333333333A192.0773333333334 192.0773333333334 0 0 1 408 317.3333333333333zM226.6666666666667 498.6666666666666L317.3333333333334 408A320.688 320.688 0 0 0 770.6666666666667 408L861.3333333333334 498.6666666666666C686.3466666666667 673.6533333333333 402.1066666666667 673.6533333333333 226.6666666666667 498.6666666666666z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
Wifi.displayName = `Blueprint5.Icon.Wifi`;
export default Wifi;
